import { Badge } from "@/components/ui/badge";
import type { BillingStatusValue } from "@/types";

export const BILLING_STATUS_LABEL: Record<BillingStatusValue, string> = {
  Active: "Em dia",
  PendingPayment: "Fatura aberta",
  Expired: "Fatura vencida",
  Canceled: "Cancelado",
  Inactive: "Sem cobrança",
  Blocked: "Bloqueado",
};

const VARIANT: Record<BillingStatusValue, "default" | "muted" | "ok" | "warning" | "error"> = {
  Active: "ok",
  PendingPayment: "warning",
  Expired: "error",
  Canceled: "muted",
  Inactive: "muted",
  Blocked: "error",
};

export function BillingStatusBadge({
  status,
  dot = false,
}: {
  status: BillingStatusValue | undefined;
  dot?: boolean;
}) {
  if (!status) {
    return (
      <Badge variant="muted" dot={dot}>
        Sem cobrança
      </Badge>
    );
  }
  return (
    <Badge variant={VARIANT[status] ?? "muted"} dot={dot}>
      {BILLING_STATUS_LABEL[status] ?? status}
    </Badge>
  );
}
